<div class="section-header">
    <div class="big-title">
        Zusammenfassung
    </div>
    <div class="header-note">
        Alle bisherigen Informationen zu dem Projekt kurzgefasst in der Übersicht.
    </div>
</div>
<div class="divider"></div>


<bd-fa-button class="arrow"
              [name]="'chevron-up'"
              *ngIf="isActivePriceApprovalMode()"
              [ngClass]="{'rotate-down':! sectionIsExpandedState.endUser}"
              (click)="sectionIsExpandedState.endUser = !sectionIsExpandedState.endUser ">
</bd-fa-button>
<ng-container *ngIf="sectionIsExpandedState.endUser else endUserTitle">
    <app-projects-simple-section-viewer [sectionType]="'END_USER'"></app-projects-simple-section-viewer>
</ng-container>
<ng-template #endUserTitle>
    <div class="section-title-replacement">Endanwenderdaten</div>
</ng-template>
<div class="divider"></div>


<bd-fa-button class="arrow"
              [name]="'chevron-up'"
              *ngIf="isActivePriceApprovalMode()"
              [ngClass]="{'rotate-down':! sectionIsExpandedState.project}"
              (click)="sectionIsExpandedState.project = !sectionIsExpandedState.project ">
</bd-fa-button>
<ng-container *ngIf="sectionIsExpandedState.project else projectTitle">
    <app-projects-simple-section-viewer [sectionType]="'PROJECT'"></app-projects-simple-section-viewer>
</ng-container>
<ng-template #projectTitle>
    <div class="section-title-replacement">Projektdaten</div>
</ng-template>
<div class="divider"></div>

<!--    Geräte, Zubehör und Full Service Pack-->
<app-project-product-summary-viewer [usePriceApprovalMode]="usePriceApprovalMode">
</app-project-product-summary-viewer>

<!--<app-projects-simple-section-viewer [sectionType]="'SUPPLIES'"></app-projects-simple-section-viewer>-->
<app-supplies-viewer [ngClass]="{'supplies-are-empty': !isSupplyOrderActive() }"></app-supplies-viewer>
<div class="divider" *ngIf="isSupplyOrderActive()"></div>


<app-supply-option-table *ngIf="isSupplyOrderActive()"
                         [usePriceApprovalMode]="usePriceApprovalMode">
</app-supply-option-table>

